import { render, staticRenderFns } from "./PageTwoColumn.vue?vue&type=template&id=24cd64d3"
import script from "./PageTwoColumn.vue?vue&type=script&lang=js"
export * from "./PageTwoColumn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports